import React, { useEffect, useState } from "react";
import axios from "axios";
import "./FeelingBored.css";

export default function FeelingBored() {
  const [activity, setActivity] = useState("");
  const [clicked, setClicked] = useState(0);

  useEffect(() => {
    axios
      .get("http://www.boredapi.com/api/activity/")
      .then((res) => setActivity(res.data.activity))
      .catch(setActivity(""));
  }, [clicked]);
  return (
    <div >
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          margin: "auto"
        }}
      >
        <a
          className="push_button red"
          style={{ textDecoration: "none", textDecorationColor: "none" }}
          onClick={() => setClicked((prev) => prev + 1)}
        >
          Feeling Bored!
        </a>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          padding: "2px",
          marginRight: "20px"
        }}
      >
        {clicked ? (
          <p
            style={{
              fontFamily: "fantasy",
              fontSize: "1.3rem",
              fontWeight: "4rem",
              color: "tomato",
              marginRight: "20px"
            }}
          >
            {activity}
          </p>
        ) : (
          ""
        )}
      </div>
    </div>
  );
}
